import styles2 from '../../AccountPage.module.css';
import styles from './AuthenticationSection.module.css';

import ContainerCard from '../../../../common/components/ContainerCard';

type AuthenticationSectionProps = {
  authEmail: string;
  toggleAuthModal: (isEmailModal: boolean) => void;
};

const AuthenticationSection = (props: AuthenticationSectionProps) => {
  const handleAuthEmailModal = () => {
    props.toggleAuthModal(true);
  };

  const handleAuthPasswordModal = () => {
    props.toggleAuthModal(false);
  };

  return (
    <ContainerCard className={styles2.cardDimensions}>
      <div className={styles.title}>AUTHENTICATION</div>
      <hr className={styles.divider} />
      <div className={styles.subtitleSmall}>EMAIL</div>
      <div className={styles.horizontalContainer}>
        <div className={styles.labelGrey}>{props.authEmail}</div>
        <a className={styles.linkBlue} onClick={handleAuthEmailModal}>
          Edit
        </a>
      </div>
      <div className={styles.subtitleSmall}>PASSWORD</div>
      <div className={styles.horizontalContainer}>
        <div className={styles.labelGrey}>***************************</div>
        <a className={styles.linkBlue} onClick={handleAuthPasswordModal}>
          Change Password
        </a>
      </div>
    </ContainerCard>
  );
};

export default AuthenticationSection;
